export const getInitials = (name?: string) => {
  if (!name) return '';

  const parts = name.trim().split(/\s+/).filter(Boolean);

  if (parts.length === 0) return '';

  const isOneWord = parts.length === 1;
  if (isOneWord) {
    return parts[0]?.substring(0, 2).toUpperCase();
  }

  const firstPart = parts[0];
  const lastPart = parts[parts.length - 1];

  if (!firstPart || !lastPart) return '';

  return `${firstPart.charAt(0).toUpperCase()}${lastPart.charAt(0).toUpperCase()}`;
};
